var map = {
	"./360ONE.png": 94124,
	"./3MINDIA.png": 51077,
	"./AADHARHFC.png": 13492,
	"./AARTIIND.png": 91635,
	"./AAVAS.png": 84716,
	"./ABB.png": 64318,
	"./ABBOTINDIA.png": 59860,
	"./ABCAPITAL.png": 67699,
	"./ABFRL.png": 2115,
	"./ACE.png": 72797,
	"./ACMESOLAR.png": 8109,
	"./ADANIENSOL.png": 98513,
	"./ADANIENT.png": 73016,
	"./ADANIGREEN.png": 94678,
	"./ADANIPORTS.png": 33563,
	"./ADANIPOWER.png": 67206,
	"./ADANITRANS.png": 97213,
	"./AEGISLOG.png": 65210,
	"./AFCONS.png": 34137,
	"./AFFLE.png": 93343,
	"./AIAENG.png": 27524,
	"./AIIL.png": 30863,
	"./AJANTPHARM.png": 69612,
	"./AKUMS.png": 80661,
	"./ALIVUS.png": 54050,
	"./ALKEM.png": 8570,
	"./ALKYLAMINE.png": 80035,
	"./ALOKINDS.png": 42666,
	"./AMBER.png": 47284,
	"./AMBUJACEM.png": 21067,
	"./ANANDRATHI.png": 97452,
	"./ANANTRAJ.png": 39780,
	"./ANGELONE.png": 94081,
	"./APARINDS.png": 23175,
	"./APLAPOLLO.png": 82690,
	"./APLLTD.png": 84282,
	"./APOLLOHOSP.png": 92537,
	"./APOLLOTYRE.png": 80090,
	"./APTUS.png": 90780,
	"./ARE&M.png": 59127,
	"./ASAHIINDIA.png": 6816,
	"./ASHOKLEY.png": 15654,
	"./ASIANPAINT.png": 19135,
	"./ASTERDM.png": 9897,
	"./ASTRAL.png": 36319,
	"./ASTRAZEN.png": 2165,
	"./ATGL.png": 77763,
	"./ATUL.png": 44839,
	"./AUBANK.png": 42699,
	"./AUROPHARMA.png": 43282,
	"./AWL.png": 67543,
	"./AXISBANK.png": 28982,
	"./BAJAJ-AUTO.png": 20386,
	"./BAJAJFINSV.png": 69268,
	"./BAJAJHFL.png": 67234,
	"./BAJAJHLDNG.png": 81088,
	"./BAJFINANCE.png": 73855,
	"./BAKISIND.png": 73158,
	"./BALRAMCHIN.png": 7573,
	"./BANDHANBNK.png": 53661,
	"./BANKBARODA.png": 61277,
	"./BANKINDIA.png": 44944,
	"./BASF.png": 58986,
	"./BAYERCROP.png": 74124,
	"./BBTC.png": 84974,
	"./BDL.png": 11242,
	"./BEL.png": 96726,
	"./BEML.png": 13277,
	"./BERGEPAINT.png": 5175,
	"./BHARATFORG.png": 79129,
	"./BHARTIARTL.png": 57705,
	"./BHARTIHEXA.png": 89235,
	"./BHEL.png": 80889,
	"./BIKAJI.png": 33737,
	"./BIOCON.png": 11189,
	"./BLS.png": 27847,
	"./BLUEDART.png": 56248,
	"./BLUESTARCO.png": 71211,
	"./BOSCHLTD.png": 67445,
	"./BPCL.png": 52126,
	"./BRIGADE.png": 56075,
	"./BRITANNIA.png": 27815,
	"./BSE.png": 83550,
	"./BSOFT.png": 90486,
	"./CAMPUS.png": 54256,
	"./CAMS.png": 99497,
	"./CANBK.png": 74721,
	"./CANFINHOME.png": 31510,
	"./CAPLIPOINT.png": 15107,
	"./CARBORUNIV.png": 45361,
	"./CASTROLIND.png": 1476,
	"./CCL.png": 64972,
	"./CDSL.png": 3473,
	"./CEATLTD.png": 90465,
	"./CENTRALBK.png": 44487,
	"./CENTURYPLY.png": 29949,
	"./CERA.png": 10403,
	"./CESC.png": 23616,
	"./CGCL.png": 36863,
	"./CGPOWER.png": 21721,
	"./CHALET.png": 18723,
	"./CHAMBLFERT.png": 91113,
	"./CHENNPETRO.png": 16512,
	"./CHOLAFIN.png": 26566,
	"./CHOLAHLDNG.png": 82902,
	"./CIPLA.png": 96464,
	"./CLEAN.png": 97946,
	"./COALINDIA.png": 90090,
	"./COCHINSHIP.png": 85874,
	"./COFORGE.png": 36529,
	"./COHANCE.png": 24989,
	"./COLPAL.png": 59235,
	"./CONCOR.png": 87383,
	"./CONCORDBIO.png": 27833,
	"./COROMANDEL.png": 27164,
	"./CRAFTSMAN.png": 30064,
	"./CREDITACC.png": 61316,
	"./CRISIL.png": 35275,
	"./CROMPTON.png": 99150,
	"./CUB.png": 31080,
	"./CUMMINSIND.png": 25278,
	"./CYIENT.png": 96905,
	"./DABUR.png": 91953,
	"./DALBHARAT.png": 92703,
	"./DATAPATTNS.png": 5949,
	"./DCMSHRIRAM.png": 7439,
	"./DEEPAKFERT.png": 99098,
	"./DEEPAKNTR.png": 82702,
	"./DELHIVERY.png": 56647,
	"./DEVYANI.png": 79468,
	"./DIVISLAB.png": 61196,
	"./DIXON.png": 28094,
	"./DLF.png": 97627,
	"./DMART.png": 11764,
	"./DOMS.png": 59459,
	"./DRREDDY.png": 34187,
	"./DUMMYDBRLT.png": 17097,
	"./DUMMYSIEMS.png": 97325,
	"./EICHERMOT.png": 21338,
	"./EIDPARRY.png": 91057,
	"./EIHOTEL.png": 58700,
	"./ELECON.png": 36041,
	"./ELGIEQUIP.png": 38963,
	"./EMAMILTD.png": 79873,
	"./EMCURE.png": 10498,
	"./ENDURANCE.png": 7316,
	"./ENGINERSIN.png": 53437,
	"./ERIS.png": 31587,
	"./ESCORTS.png": 95206,
	"./ETERNAL.png": 93456,
	"./EXIDEIND.png": 75584,
	"./FEDERALBNK.png": 55791,
	"./FIRSTCRY.png": 38553,
	"./FIVESTAR.png": 71929,
	"./FORTIS.png": 50540,
	"./FSL.png": 94985,
	"./GAIL.png": 69276,
	"./GICRE.png": 16505,
	"./GILLETTE.png": 16679,
	"./GLAND.png": 83869,
	"./GLENMARK.png": 26399,
	"./GMRAIRPORT.png": 66119,
	"./GODREJCP.png": 13052,
	"./GODREJPROP.png": 20140,
	"./GRASIM.png": 22465,
	"./GRSE.png": 63697,
	"./GVT&D.png": 70345,
	"./HAL.png": 32009,
	"./HAVELLS.png": 78790,
	"./HCLTECH.png": 37556,
	"./HDFC.png": 30271,
	"./HDFCAMC.png": 62568,
	"./HDFCBANK.png": 784,
	"./HDFCLIFE.png": 86105,
	"./HEROMOTOCO.png": 32152,
	"./HINDALCO.png": 27253,
	"./HINDPETRO.png": 82974,
	"./HINDUNILVR.png": 1280,
	"./HINDZINC.png": 75931,
	"./HUDCO.png": 51380,
	"./HYUNDAI.png": 52510,
	"./ICICIBANK.png": 65422,
	"./ICICIGI.png": 35639,
	"./ICICIPRULI.png": 32593,
	"./IDEA.png": 56995,
	"./IDFCFIRSTB.png": 75814,
	"./IGL.png": 47005,
	"./INDHOTEL.png": 80270,
	"./INDIANB.png": 25670,
	"./INDIGO.png": 34011,
	"./INDUSINDBK.png": 34838,
	"./INDUSTOWER.png": 76284,
	"./INFY.png": 23328,
	"./IOC.png": 85061,
	"./IRB.png": 49966,
	"./IRCTC.png": 60780,
	"./IREDA.png": 57260,
	"./IRFC.png": 14312,
	"./ITC.png": 96208,
	"./JINDALSTEL.png": 70683,
	"./JIOFIN.png": 67427,
	"./JSWENERGY.png": 22305,
	"./JSWSTEEL.png": 59135,
	"./JUBLFOOD.png": 14019,
	"./KALYANKJIL.png": 47857,
	"./KOTAKBANK.png": 35142,
	"./KPITTECH.png": 30317,
	"./LALPATHLAB.png": 54352,
	"./LICHSGFIN.png": 89430,
	"./LICI.png": 48585,
	"./LODHA.png": 77342,
	"./LT.png": 11183,
	"./LTF.png": 99955,
	"./LTIM.png": 34297,
	"./M&M.png": 69618,
	"./M&MFIN.png": 38763,
	"./MAHABANK.png": 32796,
	"./MANKIND.png": 31616,
	"./MAPMYINDIA.png": 48407,
	"./MARICO.png": 41630,
	"./MARUTI.png": 3872,
	"./MAXHEALTH.png": 20288,
	"./MAZDOCK.png": 24707,
	"./MFSL.png": 68657,
	"./MOTHERSON.png": 65362,
	"./MPHASIS.png": 71629,
	"./MRF.png": 17802,
	"./MUTHOOTFIN.png": 65553,
	"./NATIONALUM.png": 78452,
	"./NAUKRI.png": 20158,
	"./NESTLEIND.png": 74179,
	"./NHPC.png": 68029,
	"./NMDC.png": 18815,
	"./NTPC.png": 33975,
	"./NTPCGREEN.png": 45142,
	"./NYKAA.png": 59475,
	"./OBEROIRLTY.png": 81477,
	"./OFSS.png": 81306,
	"./OIL.png": 10180,
	"./OLAELEC.png": 66146,
	"./ONGC.png": 23942,
	"./PAGEIND.png": 20565,
	"./PATANJALI.png": 64419,
	"./PAYTM.png": 10055,
	"./PERSISTENT.png": 3912,
	"./PETRONET.png": 87997,
	"./PFC.png": 13752,
	"./PHOENIXLTD.png": 80218,
	"./PIDILITIND.png": 9598,
	"./PIIND.png": 64665,
	"./PNB.png": 45365,
	"./POLYCAB.png": 84019,
	"./POWERGRID.png": 60423,
	"./PREMIERENE.png": 53510,
	"./PRESTIGE.png": 46370,
	"./RECLTD.png": 95734,
	"./RELIANCE.png": 53697,
	"./RVNL.png": 49635,
	"./SAIL.png": 53337,
	"./SBICARD.png": 98095,
	"./SBILIFE.png": 73444,
	"./SBIN.png": 40614,
	"./SHREECEM.png": 40261,
	"./SHRIRAMFIN.png": 16335,
	"./SIEMENS.png": 64767,
	"./SJVN.png": 39466,
	"./SOLARINDS.png": 19111,
	"./SONACOMS.png": 40253,
	"./SRF.png": 59216,
	"./SUNPHARMA.png": 19965,
	"./SUPREMEIND.png": 44598,
	"./SUZLON.png": 17410,
	"./SWIGGY.png": 87204,
	"./TATACOMM.png": 5369,
	"./TATACONSUM.png": 20172,
	"./TATAELXSI.png": 65737,
	"./TATAMOTORS.png": 3012,
	"./TATAPOWER.png": 69709,
	"./TATASTEEL.png": 21580,
	"./TATATECH.png": 95548,
	"./TCS.png": 19982,
	"./TECHM.png": 33356,
	"./TIINDIA.png": 7423,
	"./TITAN.png": 31732,
	"./TORNTPHARM.png": 88872,
	"./TORNTPOWER.png": 18974,
	"./TRENT.png": 93912,
	"./TVSMOTOR.png": 38671,
	"./ULTRACEMCO.png": 60355,
	"./UNIONBANK.png": 74977,
	"./UNITDSPR.png": 67072,
	"./UPL.png": 6962,
	"./VBL.png": 50879,
	"./VEDL.png": 72339,
	"./VMM.png": 25869,
	"./VOLTAS.png": 71803,
	"./WAAREEENER.png": 83932,
	"./WIPRO.png": 1506,
	"./YESBANK.png": 88292,
	"./ZYDUSLIFE.png": 78084,
	"./default.png": 88294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69856;